import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import { t } from '../t';
/**
 * The prompt where gated content would be: sign up or log in (guests), confirm
 * your email (unconfirmed accounts), or upgrade (members outside a rule's
 * groups). Shared by the forum and the admin preview, so the preview is the
 * real thing.
 */
export default class GatePrompt extends Component {
  view() {
    const {
      compact
    } = this.attrs;
    const reason = this.attrs.gate.reason;
    return m("div", {
      className: classList('VelvetRope-prompt', `VelvetRope-prompt--${reason}`, compact && 'VelvetRope-prompt--compact'),
      role: "note"
    }, m(Icon, {
      name: reason === 'member' ? 'fas fa-crown' : 'fas fa-lock',
      className: "VelvetRope-prompt-icon"
    }), m("div", {
      className: "VelvetRope-prompt-body"
    }, m("h4", {
      className: "VelvetRope-prompt-title"
    }, this.title()), !compact && m("p", {
      className: "VelvetRope-prompt-text"
    }, t(`lib.prompt.${reason}_text`, {
      email: app.session?.user?.email?.() || ''
    }))), m("div", {
      className: "VelvetRope-prompt-actions"
    }, this.buttons()));
  }
  title() {
    const {
      gate,
      meter,
      compact
    } = this.attrs;
    if (gate.reason === 'meter' && meter && !compact) {
      return t(`lib.prompt.meter_title_${meter.period}`, {
        count: meter.limit
      });
    }
    return t(`lib.prompt.${gate.reason}_title${compact ? '_short' : ''}`);
  }
  buttons() {
    const {
      gate,
      onaction,
      preview
    } = this.attrs;
    const run = what => () => onaction?.(what, gate);
    if (gate.reason === 'confirm') {
      return m(Button, {
        className: "Button Button--primary",
        onclick: run('resend')
      }, t('lib.prompt.resend'));
    }
    if (gate.reason === 'member') {
      return gate.upgradeUrl ? m(Button, {
        className: "Button Button--primary",
        icon: "fas fa-arrow-up",
        onclick: run('upgrade')
      }, t('lib.prompt.upgrade')) : null;
    }
    return [(preview || app.forum.attribute('allowSignUp')) && m(Button, {
      className: "Button Button--primary",
      onclick: run('signUp')
    }, t('lib.prompt.sign_up')), m(Button, {
      className: "Button",
      onclick: run('logIn')
    }, t('lib.prompt.log_in'))];
  }
}
flarum.reg.add('ernestdefoe-velvet-rope', 'common/components/GatePrompt', GatePrompt);